import { t } from '@lingui/core/macro'
import { string, func } from 'prop-types'
import { CvsTextField, CvFlexBox } from '@components'

export const TransparentConfig = props => {
  const { background, xOffset, yOffset, handleChange } = props
  return (
    <>
      <CvsTextField
        fullWidth
        label={t`Background image URL (must be publicly accessible)`}
        onChange={e => handleChange('qr_code_monkey_background', e.target.value)}
        value={background}
      />
      <CvFlexBox>
        <CvsTextField
          style={{ flex: 1, marginRight: 8 }}
          label={t`Background X image offset (px)`}
          onChange={e => handleChange('qr_code_monkey_x_offset', e.target.value)}
          type="number"
          value={xOffset}
        />
        <CvsTextField
          style={{ flex: 1 }}
          label={t`Background Y image offset (px)`}
          onChange={e => handleChange('qr_code_monkey_y_offset', e.target.value)}
          type="number"
          value={yOffset}
        />
      </CvFlexBox>
    </>
  )
}

TransparentConfig.propTypes = {
  background: string.isRequired,
  xOffset: string.isRequired,
  yOffset: string.isRequired,
  handleChange: func.isRequired,
}
